import { IUser } from "@/interfaces/responses/user";

export interface IUserState {
  loading: boolean;
  user: IUser;
  userId: number | null;
}

export enum UserRole {
  ROLE_OWNER = 1,
  ROLE_MANAGER = 2,
  ROLE_SECURITY = 3,
  ROLE_SELLER = 4,
  ROLE_ACCOUNTING = 5,
  ROLE_SELLER_MANAGER = 6,
  ROLE_DEVELOPER = 7,
  ROLE_RESTRICTED_MANAGER = 8,
  ROLE_READ_ONLY = 10,
  ROLE_PROMOTER = 11,
  ROLE_NO_ROLE = 99,
  ROLE_SELLER_NO_DISCOUNT = 12,
  ROLE_POS_SELLER = 13,
  ROLE_POS_SELLER_MANAGER = 14,
}
